<template>
	<div class="cepbank_form_rsv">
        <template v-if="!iframeMode">
		<div v-if="formProcess > 0">
			<div class="alert alert-success" v-if="formProcess == 200">
				{{ t.form.success }}
			</div>
			<div class="alert alert-danger" v-if="formProcess == 403">
				<noAvailablePayment :text="t.payment_isnot_available" />
			</div>
			<div class="alert alert-danger" v-if="formProcess == 404">
				<noAvailablePayment :text="t.payment_isnot_available" />
			</div>
		</div>
		<symForm :options="opt" :data="formData" v-on:sended="getForm" :form="Form" :formProcess="formProcess" v-if="Form" />
        </template>
		<div v-if="isLoading" style="text-align: center;">
			<svg aria-labelledby="loading-40-aria" role="img" height="160" width="100%"><title id="loading-40-aria">Loading...</title><rect role="presentation" x="0" y="0" width="100%" height="100%" clip-path="url(#loading-40-diff)" style="fill: url(&quot;#loading-40-animated-diff&quot;);"></rect><defs role="presentation"><clipPath id="loading-40-diff"><rect x="0" y="13" rx="4" ry="4" width="100%" height="9"></rect><rect x="0" y="29" rx="4" ry="4" width="100" height="8"></rect><rect x="0" y="50" rx="4" ry="4" width="100%" height="10"></rect><rect x="0" y="65" rx="4" ry="4" width="100%" height="10"></rect><rect x="0" y="79" rx="4" ry="4" width="100" height="10"></rect><rect x="0" y="99" rx="5" ry="5" width="100%" height="200"></rect></clipPath><linearGradient id="loading-40-animated-diff"><stop offset="0%" stop-color="#f5f6f7" stop-opacity="1"><animate attributeName="offset" values="-2; -2; 1" keyTimes="0; 0.25; 1" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="50%" stop-color="#eee" stop-opacity="1"><animate attributeName="offset" values="-1; -1; 2" keyTimes="0; 0.25; 1" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="100%" stop-color="#f5f6f7" stop-opacity="1"><animate attributeName="offset" values="0; 0; 3" keyTimes="0; 0.25; 1" dur="1s" repeatCount="indefinite"></animate></stop></linearGradient></defs></svg>
		</div>

        <template v-if="iframeMode">
            <iframe width="100%" height="600" style="width: 100%; height: 50vh; border: 0" id="output_iframe1"></iframe>
        </template>

	</div>
</template>
<script>

    import noAvailablePayment from '@/components/payments/noAvailablePayment.vue'
    import symForm from '@/components/form/symForm.vue'
    export default {
        name: 'pepparaWithdraw',
        components: { symForm,noAvailablePayment },
        data () {
            return {
                isLoading: false,
                session: session,
                userLoader: true,
                t: this.$root.t,
                users: null,
                userId: this.$route.query.userId,
                regions: [],
                userGroup: [],
                breadcrumb: [],
                userOpened: false,
                Form: null,
                translationForm: null,
                formProcess: 0,
                opt: {
                    region: {data: [], label: 'nationallity'},
                    userGroup: {data: [], label: 'name'}
                },
                formData: [],
                iframeMode: false
            }
        },
        watch: {
            '$route.params.method' () {
                this.getForm();
            }
        },
        mounted () {
            this.getForm();

        },
        methods: {
            importParentCSSToIframe(iframeElement) {
    // Wait for iframe to load
    iframeElement.onload = function() {
        try {
            const iframeDoc = iframeElement.contentDocument || iframeElement.contentWindow.document;
            const parentStyleSheets = document.styleSheets;
            
            // Loop through all parent stylesheets
            for (let i = 0; i < parentStyleSheets.length; i++) {
                const styleSheet = parentStyleSheets[i];
                
                // Handle external stylesheets
                if (styleSheet.href) {
                    const linkElement = iframeDoc.createElement('link');
                    linkElement.rel = 'stylesheet';
                    linkElement.type = 'text/css';
                    linkElement.href = styleSheet.href;
                    iframeDoc.head.appendChild(linkElement);
                }
                // Handle inline styles
                else if (styleSheet.ownerNode && styleSheet.ownerNode.innerHTML) {
                    const styleElement = iframeDoc.createElement('style');
                    styleElement.type = 'text/css';
                    styleElement.innerHTML = styleSheet.ownerNode.innerHTML;
                    iframeDoc.head.appendChild(styleElement);
                }
            }
        } catch (error) {
            console.error('Error importing CSS to iframe:', error);
        }
    };
},
            resetStatus () {
                this.formProcess = 0;
            },
            async multiSelect () {

        var e = document.getElementsByClassName("choicesx");
        for (var i = 0; i < e.length; i++){
            var name = e[i].getAttribute("name");

            var element = e[i];

            var example = new Choices(element, {
                removeItemButton: true,

            });
        }

        //CKEDITOR.replaceAll();
    },
    async getForm (data) {
        this.iframeMode = false

        if(!this.isLoading) {
            this.isLoading = true;
            this.Form = null;
            this.formProcess = 0;
            if(data) {

                //this.Form = null;
                this.$http.post(api+'api/v1/'+this.$route.query.t+'-withdraw/methods/'+this.$route.params.method,
                    data )
                    .then(response => {

                    this.Form = response.body.result;
	                this.formProcess = 200;
	                this.isLoading = false;
                //swal('', this.t.processing.success, "success")

                setTimeout(this.resetStatus, 5000);

            }, response => {
                    this.Form = response.body.result;
                    this.formProcess = 400;
                    this.isLoading = false;

                    //swal(this.t.processing.error, this.t.processing.check, "error")
                })

            } else {


                this.$http.get(api+'api/v1/'+this.$route.query.t+'-withdraw/methods/'+this.$route.params.method)
                    .then(response => {


	                this.isLoading = false;

                    if(response.body.iframe) {
                            this.iframeMode = true
                            setTimeout(() => {

                                let html_string= response.body.result;
                                let myIframe = document.getElementById('output_iframe1');
                                // myIframe.src = `data:text/html;charset=utf-8,${html_string}`;
                                myIframe.srcdoc = html_string;
                                this.importParentCSSToIframe(myIframe)
                                
                            }, 100);
                    } else {
                        this.Form = response.body.result;
                        this.formData = response.body.form_data;
                        this.opt.userGroup.label = 'group_name'
                    }            

            }, response => {
                    this.isLoading = false;
                    this.formProcess = response.status;
                })
            }
        }
    },
    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/payments/form/extendWithdraw.vue